/**
 * Single fetch wrapper (avoids stacking with a second script — Android Chrome + OCU are sensitive to that):
 * 1) Refreshes cart UI when apps call Cart API without theme `sections` in JSON.
 * 2) Schedules app-trial subscription inject (same IDs as main-cart-items v2/v3).
 *
 * For ?ocu (One Click Upsell): do not clone/read the response body here — OCU may need exclusive
 * access; we only debounce a drawer refresh.
 */
(function () {
  if (typeof window.fetch !== 'function') return;

  const originalFetch = window.fetch;
  let debounceTimer;

  const TRIGGER_VARIANT_IDS = [
    51956110688626, 51956118520178, 51956112327026, 51956380270962, 51956380762482, 51956381090162,
    51956381516146, 51956381909362, 51956382204274, 51956382597490, 51956382794098, 51956383089010,
    51956377878898, 52313216319858, 52313282445682, 52313296142706, 52359412875634, 61543495139698,
    61543510737266, 61543510770034, 51956377190770,
  ];
  const APP_VARIANT_ID = 52286607032690;
  const SELLING_PLAN_ID = 690873762162;

  var _appTrialInjectTimer = null;
  function scheduleAppTrialInjectCheck() {
    if (_appTrialInjectTimer) clearTimeout(_appTrialInjectTimer);
    _appTrialInjectTimer = setTimeout(function () {
      _appTrialInjectTimer = null;
      checkAndInjectAppProduct();
    }, 550);
  }

  function getFetchUrl(arg) {
    if (typeof arg === 'string') return arg;
    if (arg && typeof Request !== 'undefined' && arg instanceof Request) return arg.url;
    if (typeof URL !== 'undefined' && arg instanceof URL) return arg.href;
    return '';
  }

  function isOcuCartRequest(urlString) {
    return typeof urlString === 'string' && urlString.indexOf('ocu') !== -1;
  }

  function isCartApiUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(url);
  }

  function isCartMutationUrl(urlString) {
    if (!urlString) return false;
    try {
      const path = new URL(urlString, window.location.href).pathname;
      return (
        path.endsWith('/cart/add') ||
        path.endsWith('/cart/add.js') ||
        path.endsWith('/cart/change') ||
        path.endsWith('/cart/change.js') ||
        path.endsWith('/cart/update') ||
        path.endsWith('/cart/update.js')
      );
    } catch (e) {
      return (
        urlString.includes('/cart/add') ||
        urlString.includes('/cart/change') ||
        urlString.includes('/cart/update')
      );
    }
  }

  function responseHasThemeSections(data) {
    return (
      data &&
      typeof data === 'object' &&
      data.sections &&
      typeof data.sections === 'object' &&
      Object.keys(data.sections).length > 0
    );
  }

  function syncCartUi() {
    if (typeof publish === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external-cart-sync' });
  }

  function refreshCartDrawerAfterAppInject() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !window.routes || !window.routes.cart_url) return;
    const wasOpen = cartDrawer.classList.contains('active');
    const hadAnimate = cartDrawer.classList.contains('animate');
    fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceCartDrawer = html.querySelector('cart-drawer');
        if (cartDrawer && sourceCartDrawer) {
          cartDrawer.className = sourceCartDrawer.className;
          if (wasOpen) {
            cartDrawer.classList.add('active');
            if (hadAnimate) cartDrawer.classList.add('animate');
            document.body.classList.add('overflow-hidden');
          }
          const targetInner = cartDrawer.querySelector('.drawer__inner');
          const sourceInner = sourceCartDrawer.querySelector('.drawer__inner');
          if (targetInner && sourceInner) {
            targetInner.replaceWith(sourceInner);
          }
          const newOverlay = cartDrawer.querySelector('#CartDrawer-Overlay');
          if (newOverlay && typeof cartDrawer.close === 'function') {
            newOverlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
          }
          if (typeof cartDrawer.updateShippingBanner === 'function') {
            cartDrawer.updateShippingBanner();
          }
          setTimeout(function () {
            try {
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'app-trial-inject' } }));
              document.dispatchEvent(new CustomEvent('shopify:cart:update', { bubbles: true, detail: { source: 'app-trial-inject' } }));
            } catch (e) {}
          }, 0);
        }
      })
      .catch(function (e) {
        console.error(e);
      });
  }

  function refreshCartHeaderBubbleAfterAppInject() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    try {
      const u = new URL(window.location.href);
      u.searchParams.set('section_id', 'cart-icon-bubble');
      fetch(u.toString())
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const wrap = doc.querySelector('.shopify-section') || doc.querySelector('[id^="shopify-section-"]');
          let inner = wrap ? wrap.innerHTML.trim() : '';
          if (!inner && doc.body) inner = doc.body.innerHTML.trim();
          if (!inner) return;
          const probe = new DOMParser().parseFromString('<div>' + inner + '</div>', 'text/html');
          const nestedA = probe.querySelector('a#cart-icon-bubble');
          if (nestedA) inner = nestedA.innerHTML;
          bubble.innerHTML = inner;
        })
        .catch(function () {});
    } catch (e) {
      /* ignore */
    }
  }

  function checkAndInjectAppProduct() {
    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        const hasTrigger = cart.items.some(function (item) {
          return TRIGGER_VARIANT_IDS.indexOf(item.variant_id) !== -1;
        });
        const hasApp = cart.items.some(function (item) {
          return item.variant_id === APP_VARIANT_ID;
        });
        if (!hasTrigger || hasApp) {
          return;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: APP_VARIANT_ID, quantity: 1, selling_plan: SELLING_PLAN_ID }],
          }),
        }).then(function () {
          console.log('App product injected into cart');
          refreshCartDrawerAfterAppInject();
          refreshCartHeaderBubbleAfterAppInject();
        });
      })
      .catch(function (err) {
        console.error('Error injecting app product:', err);
      });
  }

  (function wireAppTrialCartUpdateListener(attempt) {
    attempt = attempt || 0;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'cart-items') return;
        scheduleAppTrialInjectCheck();
      });
      return;
    }
    if (attempt > 60) return;
    setTimeout(function () {
      wireAppTrialCartUpdateListener(attempt + 1);
    }, 50);
  })();

  /** Backup: some add/refresh paths dispatch events without hitting our fetch wrapper. */
  document.addEventListener('cart:updated', scheduleAppTrialInjectCheck);
  document.addEventListener('shopify:cart:update', scheduleAppTrialInjectCheck);

  window.fetch = function () {
    var args = arguments;
    return originalFetch.apply(this, args).then(function (response) {
      try {
        var url = getFetchUrl(args[0]);

        if (isCartMutationUrl(url) && url.indexOf('ocu') === -1) {
          scheduleAppTrialInjectCheck();
        }

        if (!response.ok || !isCartApiUrl(url)) {
          return response;
        }

        var contentType = response.headers.get('content-type') || '';
        if (contentType.indexOf('application/json') === -1) {
          return response;
        }

        if (isOcuCartRequest(url)) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(syncCartUi, 750);
          return response;
        }

        var clone = response.clone();
        clone
          .json()
          .then(function (data) {
            if (responseHasThemeSections(data)) return;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(syncCartUi, 50);
          })
          .catch(function () {});
      } catch (_) {
        /* ignore */
      }
      return response;
    });
  };
})();
